import { render, staticRenderFns } from "./ChemCPP1220S4Q1.vue?vue&type=template&id=7a6505d0&"
import script from "./ChemCPP1220S4Q1.vue?vue&type=script&lang=js&"
export * from "./ChemCPP1220S4Q1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
